export const home = {
  // Navigation
  nav_spreadsheet: "Spreadsheet",
  nav_guides: "Guides",
  nav_categories: "Categories",
  nav_review: "Review",
  nav_shipping: "Shipping",
  nav_safety: "Safety",
  nav_blog: "Blog",
  nav_home: "Home",
  nav_shopping_guide: "Shopping Guide",
  nav_about: "About",
  nav_contact: "Contact",
  
  // Language selector
  lang_english: "English",
  lang_french: "Français",
  lang_german: "Deutsch",
  lang_danish: "Dansk",
  
  // Hero
  hero_eyebrow: "THE ALLCHINABUY SPREADSHEET RESOURCE HUB",
  hero_h1: "AllChinaBuy Spreadsheet — Find Products, Sellers & Buying Resources Faster",
  hero_subheadline: "Discover useful AllChinaBuy spreadsheets, trusted seller resources, product guides, QC information, shipping tips and buying guides — all organized in one simple resource hub.",
  hero_cta_primary: "Explore AllChinaBuy Spreadsheet",
  hero_cta_secondary: "Browse Popular Resources",
  hero_trust: "Independent resource • Updated regularly • Built for easier product discovery",
  
  // Search Module
  search_title: "Find the AllChinaBuy Spreadsheet Resource You Need",
  search_placeholder: "Search products, sellers, shipping, QC, warehouse...",
  search_button: "Search",
  search_popular: "Popular searches",
  search_popular_items: "Clothing • Shoes • Fashion • QC • Shipping • Sellers",
  
  // Spreadsheet Hub Section
  hub_h2: "AllChinaBuy Spreadsheet: Your Starting Point",
  hub_copy: "Looking for products, sellers or useful buying information? Start with the AllChinaBuy Spreadsheet hub and explore organized resources by category, product type and search intent.",
  hub_cta: "Explore the Spreadsheet Hub →",
  
  // Popular Categories
  categories_h2: "Popular AllChinaBuy Spreadsheet Categories",
  categories_clothing: "Clothing",
  categories_clothing_desc: "Browse the latest AllChinaBuy clothing spreadsheet with trusted sellers, quality items, and sizing guides for streetwear, casual wear, and designer-inspired pieces.",
  categories_shoes: "Shoes",
  categories_shoes_desc: "Explore the AllChinaBuy shoes spreadsheet featuring sneakers, boots, sandals, and more from verified sellers with detailed QC information.",
  categories_fashion: "Fashion",
  categories_fashion_desc: "Discover trending fashion items in the AllChinaBuy spreadsheet — curated collections, seasonal picks, and style guides to elevate your wardrobe.",
  categories_electronics: "Electronics",
  categories_electronics_desc: "Find electronics and gadgets in the AllChinaBuy product spreadsheet, including accessories, tech wearables, and everyday devices.",
  categories_accessories: "Accessories",
  categories_accessories_desc: "Shop belts, bags, jewelry, watches, and more through the AllChinaBuy accessories spreadsheet with detailed seller ratings.",
  categories_sellers: "Trusted Sellers",
  categories_sellers_desc: "Access the AllChinaBuy trusted seller spreadsheet with verified reviews, ratings, and product specialties to shop with confidence.",
  
  // Latest Resources
  resources_h2: "Latest AllChinaBuy Resources",
  resources_read: "Read Guide →",
  pillar_h2: "AllChinaBuy Pillar Guides",
  pillar_subtitle: "In-depth articles covering every part of the AllChinaBuy buying journey",
  
  // Buying Guides
  guides_h2: "AllChinaBuy Buying Guides",
  guides_qc: "QC Guide",
  guides_qc_desc: "Learn how to request, read, and evaluate QC photos before shipping your AllChinaBuy orders.",
  guides_shipping: "Shipping Guide",
  guides_shipping_desc: "Compare shipping methods, understand costs, timelines, and choose the best option for your country.",
  guides_warehouse: "Warehouse Guide",
  guides_warehouse_desc: "Understand how the AllChinaBuy warehouse process works — storage, inspection, packaging, and dispatch.",
  guides_seller: "Seller Guide",
  guides_seller_desc: "Tips for finding reliable sellers, reading reviews, and avoiding common mistakes when shopping.",
  guides_safety: "Safety Guide",
  guides_safety_desc: "Protect yourself with best practices for account security, payment safety, and scam awareness.",
  
  // Review Section
  review_h2: "AllChinaBuy Review",
  review_copy: "Looking for an unbiased overview? Explore our AllChinaBuy review covering key features, shopping workflow, warehouse information, shipping considerations, safety tips and important things to know before using the platform.",
  review_cta: "Read the AllChinaBuy Review →",
  
  // Safety Section
  safety_h2: "Shop Smarter: AllChinaBuy Safety Guide",
  safety_copy: "Before purchasing, understand seller verification, QC photos, payment security, suspicious links, account protection and common shopping risks.",
  safety_cta: "Read the Safety Guide →",
  
  // Final CTA
  final_cta_h2: "Ready to Explore AllChinaBuy Resources?",
  final_cta_copy: "Start with the AllChinaBuy Spreadsheet and discover product, seller, shipping and buying resources organized for faster research.",
  final_cta_primary: "Explore AllChinaBuy Spreadsheet",
  final_cta_secondary: "Visit Our Main Website",
  
  // Category Dropdown
  dropdown_title: "Shop Categories",
  dropdown_all: "All Categories",
  
  // Main CTAs
  btn_main_site: "AllChinaBuy Spreadsheet",
  btn_buy_now: "Buy It Now",
  
  // Footer
  footer_spreadsheet: "Spreadsheet",
  footer_guides: "Guides",
  footer_reviews: "Reviews",
  footer_shipping: "Shipping",
  footer_safety: "Safety",
  footer_resources: "Resources",
  footer_about: "About",
  footer_contact: "Contact",
  footer_privacy: "Privacy Policy",
  footer_terms: "Terms",
  footer_disclaimer: "Disclaimer",
  footer_disclaimer_text: "AllChinaBuy Spread is an independent informational resource and is not affiliated with or operated by AllChinaBuy unless explicitly stated.",
  footer_copyright: "© 2026 AllChinaBuy Spreadsheet. All rights reserved.",
  
  // Meta
  meta_title: "AllChinaBuy Spreadsheet 2026: Complete Guide & Best Resources",
  meta_description: "Discover the AllChinaBuy Spreadsheet — your independent resource hub for products, sellers, QC guides, shipping tips, and buying resources. Updated regularly.",
  
  // Category names (for dropdown)
  cat_shoes: "Shoes",
  cat_hoodies: "Hoodies/Sweaters",
  cat_tshirts: "T-Shirts",
  cat_jackets: "Jackets",
  cat_pants: "Pants/Shorts",
  cat_headwear: "Headwear",
  cat_sets: "Sets",
  cat_underwear: "Underwear/Underpants",
  cat_jersey: "Jersey",
  cat_accessories: "Accessories",
  cat_bags: "Bags",
  cat_belts: "Belts",
  cat_perfumes: "Perfumes",
  cat_other: "Other Stuff",
};